
import { useLocale } from "../../services/DataContext";

export const Footer: React.FC<any> = () => {
  const l: any = useLocale();
  return <footer className="footer">
    <p dangerouslySetInnerHTML={{ __html: l["footer"] }}>
    </p>
  </footer>
}